module.exports = __webpack_public_path__ + "img/c1.517b044d.png";